var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"room-wrapper"}},[_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.roomData.uuid))]),_vm._v(" "),_c('room-help',{attrs:{"orgdata":_vm.helpData},on:{"stringUpdated":function($event){return _vm.updateMedia(...arguments)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }